module.exports = __webpack_public_path__ + "img/half-circle.4822f803.svg";